import clsx from 'clsx';
import type { HTMLAttributes, ForwardRefRenderFunction } from 'react';
import { forwardRef } from 'react';

interface SidebarHeaderProps extends HTMLAttributes<HTMLDivElement> {
	children?: React.ReactNode;
	className?: string;
}

const SidebarHeader: ForwardRefRenderFunction<
	HTMLDivElement,
	SidebarHeaderProps
> = ({ children, className, ...rest }, ref) => {
	return (
		<div
			ref={ref}
			className={clsx('sideNav-header', className)}
			{...rest}
		>
			{children}
		</div>
	);
};

export default forwardRef(SidebarHeader);
